<template>
    <div>
      <div class="container-fluid wow fadeInUp" data-wow-delay="0.1s">
            <div class="container">
                <div class="row g-5">
                    <div class="col-12 text-center">
                        <nav aria-label="breadcrumb" class="float-right">
                            <ul class="breadcrumb">
                                <li class="breadcrumb-item"><a href="javascript:void(0)" @click="$router.push({ path: '/'})">Home</a></li>
                                <li class="breadcrumb-item active" aria-current="page">Videos</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
        <!-- Blog Start -->
        <div class="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
            <div class="container py-5">
                <div class="row g-5">
                    <!-- Blog list Start -->
                    <div class="col-lg-12">
                        <div class="section-title position-relative pb-3 mb-3">
                            <h1>Package Disabler Videos</h1>
                        </div>
                        <div class="row g-5" v-if="tableData.length > 0">
                            <div class="col-md-4 wow slideInUp" data-wow-delay="0.1s" v-for="item in tableData" :key="item._id">
                                <div class="blog-item bg-light rounded overflow-hidden">
                                    <div class="blog-img position-relative overflow-hidden">
                                        <iframe width="340" height="240" :src="item.link" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                    </div>
                                    <div class="p-4">
                                        <h4 class="mb-3">{{ item.title }}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            No data found
                        </div>
                    </div>
                    <!-- Blog list End -->
                </div>
            </div>
        </div>
        <!-- Blog End -->

    </div>
</template>
<script>
// @ is an alias to /src
import HomeDataService from "../services/HomeDataService";

export default {
  name: 'Videos',
  created () {
    let currentUrl = window.location.href;
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical !== null) {
        canonical.href = currentUrl;
    }
  },
  components: {
  },
  data() {
    return {
      isDisabled: false,
      tableData: [],
    };
  },
  methods: {
    videoList() {
        HomeDataService.videoList()
        .then((response) => {
          this.tableData = response.data.data; 
        })
        .catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    }
  },
  beforeMount() {
    this.videoList();
  },
}
</script>